module.exports = __webpack_public_path__ + "media/images/handshake-73c381b46bd390bb487a3c9dc73ee06f.png";